var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"tc13"}},[_vm._t("product"),_vm._t("bt_purchase"),(_vm.basePath === '/gold/')?_c('ShoppingGuideGold',{attrs:{"id":"shopping-guide"}}):_c('ShoppingGuide',{attrs:{"id":"shopping-guide"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }